import React from 'react';
import TopQuestion from '../../utils/question/topQuestion';
import { connect } from 'react-redux';
import SpeechRecorder from '../sa/saSpeechRecorder';
import TextArea from '../../utils/test/textarea';

const mapStateToProps = (state) => {
	const {
		rightSectionProps: { choices },
		leftSectionProps: { videoId, question, imagesrc, queDesc, qdomain, prompt },
		questionId
	} = state.rootReducer.testPageDetails;

	return {
		choices,
		videoId,
		question,
		imagesrc,
		queDesc,
		qdomain,
		prompt,
		questionId
	};
};
const SaSpeech = ({
	choices,
	videoId,
	question,
	imagesrc,
	queDesc,
	qdomain,
	prompt,
	questionId
}) => {
	return (
		<section className="que-container">
			<section className="quiz-page-content">
				<TopQuestion />
				<section className="quiz-area-options">
					<h6>{prompt}</h6>
					{qdomain === 'S' ? <SpeechRecorder key={questionId} /> : <TextArea key={questionId} />}
				</section>
			</section>
		</section>
	);
};

export default connect(mapStateToProps)(SaSpeech);
